"use strict";
exports.__esModule = true;
//# sourceMappingURL=investors-tab-content.js.map